<template>
  <div class="min-h-screen bg-gray-100">
    <!-- Header -->
    <header class="bg-white shadow-sm">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="flex justify-between h-16">
          <div class="flex items-center">
            <div class="h-10 w-10 rounded-xl bg-orange-500 flex items-center justify-center">
              <span class="text-white text-xl font-bold">S</span>
            </div>
            <span class="ml-3 text-xl font-semibold text-gray-900">Super Admin</span>
          </div>
          
          <div class="flex items-center space-x-4">
            <span class="text-sm text-gray-600">{{ authStore.user?.full_name }}</span>
            <button
              @click="handleLogout"
              class="text-sm text-red-600 hover:text-red-800 font-medium"
            >
              Sair
            </button>
          </div>
        </div>
      </div>
    </header>
    
    <!-- Navigation -->
    <nav class="bg-white border-b border-gray-200">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="flex space-x-8">
          <router-link
            to="/superadmin"
            class="py-4 px-1 border-b-2 font-medium text-sm"
            :class="$route.path === '/superadmin' ? 'border-orange-500 text-orange-600' : 'border-transparent text-gray-500 hover:text-gray-700'"
          >
            Empresas
          </router-link>
          <router-link
            to="/superadmin/users"
            class="py-4 px-1 border-b-2 font-medium text-sm"
            :class="$route.path === '/superadmin/users' ? 'border-orange-500 text-orange-600' : 'border-transparent text-gray-500 hover:text-gray-700'"
          >
            Usuários
          </router-link>
          <router-link
            to="/superadmin/business-plans"
            class="py-4 px-1 border-b-2 font-medium text-sm"
            :class="$route.path === '/superadmin/business-plans' ? 'border-orange-500 text-orange-600' : 'border-transparent text-gray-500 hover:text-gray-700'"
          >
            Planos de Negócios
          </router-link>
          <router-link
            to="/superadmin/orders-report"
            class="py-4 px-1 border-b-2 font-medium text-sm"
            :class="$route.path === '/superadmin/orders-report' ? 'border-orange-500 text-orange-600' : 'border-transparent text-gray-500 hover:text-gray-700'"
          >
            Pedidos por Cliente
          </router-link>
        </div>
      </div>
    </nav>
    
    <!-- Content -->
    <main class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <router-view />
    </main>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/stores'

const router = useRouter()
const authStore = useAuthStore()

const handleLogout = () => {
  authStore.logout()
  router.push('/superadmin/login')
}
</script>
